import { AnalyticsDataLayer } from './definitions';

export class AnalyticsFactory
{
	public static buildDataLayerInstance(): AnalyticsDataLayer
	{
		return {
			event: null
		};
	}
}
